import cn from 'classnames'
import * as React from 'react'
import { useIntl } from '@/intl'
import styles from '@/scopes/checkout/components/PersonalDetailsForm/Form.module.css'
import formInputStyles from '@/scopes/checkout/components/PersonalDetailsForm/Inputs/FormInput.module.css'
import { useTrackFieldValidation } from '@/scopes/checkout/components/PersonalDetailsForm/useTrackFieldValidation'
import { FieldOption } from '@/scopes/checkout/domain/types/checkoutPersonalDetails'
import { DropdownInput } from '@/scopes/common/components/FormElements/DropdownInput'

export function CountryInput({
  name,
  required,
  items,
}: {
  name: string
  required?: boolean
  items: FieldOption[]
}) {
  const intl = useIntl()
  useTrackFieldValidation(name)

  return (
    <DropdownInput
      name={name}
      items={items.map(({ value, name }) => ({ value, text: name }))}
      label={intl.formatMessage({ id: 'checkout_steps_participants_form_field_label_country' })}
      required={required}
      requiredErrorMessage={intl.formatMessage({ id: 'checkout_steps_participants_form_field_required_error_message_country' })}
      formFieldClass={cn(styles.personalDetailsFormField, formInputStyles.formFieldM)}
      placeholder={intl.formatMessage({ id: 'checkout_steps_participants_form_field_placeholder_country' })}
    />
  )
}
